import { SVGANIMATIONELEMENT } from '../../../../../enums/SVGANIMATIONELEMENT.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
import SVGANIMATION from '../../../../DOM/svg/SVGOBJECT/SVGANIMATION.js';
;
// Model Structure
export const svgSetAttr = makeAttrStruct([
    ['attributeName'],
    ['to'],
    ['begin']
]);
export const svgSetData = makeDataStruct([]);
export const svgSetModel = makeStruct([
    ['attributes', svgSetAttr],
    ['data', svgSetData]
]);
// Simplified Model
export function svgSet(attributeName, to, begin) {
    return {
        attributes: svgSetAttr(attributeName, to, begin),
        data: svgSetData()
    };
}
/** Creates an animation object for an SVG Shape */
export default class SVGSET extends SVGANIMATION {
    constructor(node, model) {
        super(node, SVGANIMATIONELEMENT.SET, model);
    }
}
